import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDocument } from "../../Persist/AbstractDocumentPersister";
import * as documentStages from "../../Stages/StagesDocument";
import { stageMetaDataDocument } from "../../Stages/StagesDocument";
import * as documentStatus from "../../LeadStatus/StatusDocument";
import documentTransformations from "../FormTransformations/documentTransformations";
import { stageFormDefinition as stageFormDefinitionDocument } from "../FormDefinitions/document";
import { fullFormDefinition as fullFormDefinitionPatientDecree } from "../FormDefinitions/patientDecree";
import { inquiryTypeAvailability } from "../../inquiryService";
import { placeholderPaymentTypeSwitchData } from "./productServiceFunctions";

export const patientDecree: ProductData = {
  urlPart: "patientenverfuegung",
  lbUrlPart: "patientenverfuegung",
  label: translate("patientDecree.label"),
  generalLabel: translate("patientDecree.label"),
  apiUri: "patient_decrees",
  persist: persistDocument,
  stages: stageMetaDataDocument,
  stageConstants: documentStages,
  minimumCaseStatus: documentStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: documentStages.STAGE_INCOMPLETE,
  setBackCaseStage: documentStages.STAGE_READY,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: () => false,
  lbProductClass: "App\\Entity\\Legalbird\\Document\\PatientDecree",
  formTransformations: documentTransformations,
  formDefinition: ({ product }) => stageFormDefinitionDocument(product.productClassName),
  formDefinitionExternals: () => [],
  fullFormDefinition: () => fullFormDefinitionPatientDecree,
  productSpecificDefinition: () => [],
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: () => false,
  inquiryTypeAvailability: inquiryTypeAvailability.patientDecree,
};
